import React, { useEffect, useState } from "react";

import MobileTable from "../../../Tables/mobile/MobileTable";
import DesktopTable from "../../../Tables/desktop/DesktopTable";
import FormModal from "../../../Modals/FormModal";

import { useInventoryTransferQuery } from "../../../../hooks/inventory/useInventoryTransferQuery";
import { useInventoryTransfer } from "../../../../hooks/inventory/useInventoryTransfer";
import { useAuthUser } from "../../../../hooks/auth/useAuthUser";

import { pendingTransferColumns } from "../columns/pendingTransferColumns";

import SearchBar from "../../../Forms/SearchBar/SearchBar";
import SvgIcon from "../../../SvgIcon/SvgIcon";
import { getFilteredTransferActions } from "../config/transferActionsConfig";

interface PendingTransferModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PendingTransferModal: React.FC<PendingTransferModalProps> = ({
  isOpen,
  onClose,
}) => {
  const {
    pendingTransfers,
    searchResults,
    handlerGetPendingTransfers,
    handlerSearchActiveTransfers,
    handlerGetTransferById,
  } = useInventoryTransferQuery();

  const { handlerOpen, openCreateModal } = useInventoryTransfer();
  const { hasRole } = useAuthUser();

  const [search, setSearch] = useState("");

  useEffect(() => {
    if (isOpen) {
      handlerGetPendingTransfers();
      setSearch("");
    }
  }, [isOpen]);

  useEffect(() => {
    if (search.trim()) {
      handlerSearchActiveTransfers(search);
    }
  }, [search]);

  /** 📌 Acción dinámica que evalúa por cada row */
  const actions = (row) =>
    getFilteredTransferActions(row, {
      hasRole,
      handlerGetTransferById,
      handlerOpen,
    });

  const tableData = search.trim() ? searchResults : pendingTransfers;

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Traslados Pendientes"
      maxWidth="max-w-6xl"
    >
      {/* 🔎 Buscador + Botón */}
      <div className="mb-4 flex items-center justify-between">
        <div className="w-full sm:w-1/2">
          <SearchBar
            value={search}
            onChange={setSearch}
            placeholder="Buscar..."
            iconKey="search"
          />
        </div>

        <button
          type="button"
          onClick={openCreateModal}
          className="ml-4 inline-flex items-center gap-2 rounded bg-primary px-4.5 py-2.5 text-sm font-medium text-white hover:bg-opacity-90"
        >
          <SvgIcon name="plus" />
          Nuevo Traslado
        </button>
      </div>

      {/* 📱 Mobile */}
      <div className="block lg:hidden">
        <MobileTable
          title="Traslados Pendientes"
          description="Consulta y completa traslados en curso."
          data={tableData}
          columns={pendingTransferColumns}
          actions={actions}
          noDataMessage="No hay traslados pendientes."
        />
      </div>

      {/* 💻 Desktop */}
      <div className="hidden lg:block">
        <DesktopTable
          data={tableData}
          columns={pendingTransferColumns}
          actions={actions}
          noDataMessage="No hay traslados pendientes."
        />
      </div>
    </FormModal>
  );
};

export default PendingTransferModal;
